/**
 *
 *Code Rule Manager : 编码规则管理

DELETE /v1/code-rule-dist
租户级删除编码规则分配

POST /v1/code-rule-dist
租户级新增和更新编码规则分配

GET /v1/code-rule/one
查询获取编码规则、编码规则分配、编码规则明细

GET /v1/code-rule/rule-code
查询获取编码规则、编码规则分配、编码规则明细

 *
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/spfm/v1/{organizationId}',
  items: [
    { key: 'getCodeRule', url: '/code-rule', method: 'GET' },
    { key: 'addCodeRule', url: '/code-rule', method: 'POST' },
    { key: 'deleteCodeRule', url: '/code-rule', method: 'DELETE' },
    { key: 'detailCodeRule', url: '/code-rule/{ruleId}', method: 'GET' },
    {
      key: 'detailCodeRuleDistId',
      url: '/code-rule-detail/{ruleDistId}',
      method: 'GET',
    },
    // 租户级新增和更新编码规则明细
    { key: 'addCodeRuleDetail', url: '/code-rule-detail', method: 'POST' },
    { key: 'deleteCodeRuleDetail', url: '/code-rule-detail', method: 'DELETE' },
  ],
};

export default {
  ...generate(config),
};
